var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-sidebar",class:{ collapsed: _vm.isSideNavCollapsed }},[_c('div',{staticClass:"sidebar-items-container"},[_c('sidebar-items')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }